module.exports = __webpack_public_path__ + "media/images/hdr_bg-db4e535f8ef145b8ce78a4d0c2dd32f8.png";